// extracted by mini-css-extract-plugin
module.exports = {"user":"Index_user__3YoHh"};